import React, { useState } from "react";
import Layout from "../../components/layout/Layout";
import { useSearchParams, useParams } from "react-router-dom";
import useRead from "../../hooks/useRead";
import usePut from "../../hooks/usePut";
import Moment from "react-moment";
import Pagination from "../../components/pagination";
import toast from "react-hot-toast";
import PrimaryLoader from "../../components/common/PrimaryLoader";
import { EyeIcon, LocationMarkerIcon } from "@heroicons/react/solid";
import DatePicker from "react-datepicker";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import LocationDisplay from "../../utils/LocationDisplay";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const SinglePersonWebcheckin = () => {
  const PunchTypes = {
    punch_in: "Punch In",
    punch_out: "Punch Out",
  };
  const punchApproveTypes = [
    {
      name: "Approve",
      value: "1",
    },
    {
      name: "Pending",
      value: "2",
    },
    {
      name: "Reject",
      value: "0",
    },
  ];
  const [searchParams, setSearchParams] = useSearchParams();
  const { company_employee_id } = useParams();
  const name = searchParams.get("name");
  const breadcrumbs = [
    {
      label: "Web Check Ins",
      link: "/web-check-ins",
    },
    {
      label: "Web Check In Details",
      link: ``,
    },
  ];
  let initialFilter = {
    month_and_year: searchParams.get("month_and_year") || new Date(),
    company_employee_id: company_employee_id,
    page_number: 0,
    limit: 10,
  };

  const [checkInData, setCheckInData] = useState([]);
  const { list, paramsObject, setGetListParams } = useRead({
    url: "checked_in_user_list",
    initialData: initialFilter,
    onSuccess: (res) => {
      setCheckInData(res.data);
    },
    onError: () => {
      toast.error(
        "There was an error while retrieving the data; please try again later."
      );
    },
  });
  const statusChange = usePut({
    url: "approve_punch_details",
    onSuccess: () => {
      toast.success("Status Updated Successfully");
    },
    onError: () => {
      toast.error(
        "There was an error while retrieving the data; please try again later."
      );
    },
  });
  const handleChangeStatus = (e, id, index) => {
    let params = {
      approval_status: e.target.value,
      id,
    };
    let data = checkInData;
    data[index]["approval_status"] = e.target.value;
    setCheckInData(checkInData);
    statusChange.handleAuth.mutate(params);
  };
  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
      name: searchParams.get("name"),
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  const handleDate = (value, name) => {
    let data = {
      ...paramsObject,
      [name]: value,
      page_number: 0,
      name: searchParams.get("name"),
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  console.log(list?.data?.data);

  return (
    <div className="pt-5">
      <div className="px-4 my-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      <h1 className="text-2xl px-4 font-semibold text-gray-700">
          {name}'s Web Check Ins
        </h1>

      <div className=" w-[25%] px-4">
        <label className=" roboto p-2 label">Select Month/Year</label>
        <DatePicker
          required
          name="month_and_year"
          autoComplete="false"
          className="input"
          dateFormat="MM/yyyy"
          showMonthYearPicker
          selected={paramsObject?.month_and_year}
          onChange={(value) => handleDate(value, "month_and_year")}
        />
      </div>
      {list.isLoading && (
        <div className=" fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 bg-[#ffffffc7]">
          <PrimaryLoader />
        </div>
      )}
      <div className="mb-12">
        {list.data?.data?.length <= 0 ? (
          <p className=" text-center font-semibold text-gray-700 mt-10">
            No Data Found
          </p>
        ) : (
          <div>
            <RoundedContainer className="mx-4 mt-6">
              <div className="max-w-full overflow-x-auto">
                <Table className="table-auto w-full">
                  <TableHead>
                    <TableHeaderCell className="w-[8%] text-center">
                      Sr.No
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[12%] text-center">
                      Punch Type
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[18%] text-center">
                      Time
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[12%] text-center">
                      Employee Photo
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[12%] text-center">
                      Screen Photo
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[16%] text-center">
                      Location
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[10%] text-center">
                      Remarks
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[12%] text-center">
                      Approval Status
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    {checkInData?.map((data, idx) => {
                      const {
                        id,
                        punch_time,
                        punch_type,
                        approval_status,
                        full_screen_image_url,
                        image_url,
                        location_lat,
                        location_long,
                        remarks,
                      } = data;
                      return (
                        <TableRow key={idx}>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {idx + 1}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {punch_type}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            <Moment date={punch_time} unix format="llll" />
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {image_url ? (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={image_url}
                                className="inline-flex items-center justify-center text-primary hover:text-blue-700"
                              >
                                <EyeIcon className="w-5 h-5 cursor-pointer" />
                              </a>
                            ) : (
                              "---"
                            )}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {full_screen_image_url ? (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={full_screen_image_url}
                                className="inline-flex items-center justify-center text-primary hover:text-blue-700"
                              >
                                <EyeIcon className="w-5 h-5 cursor-pointer" />
                              </a>
                            ) : (
                              "---"
                            )}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            <div className="flex items-center justify-center">
                              <LocationDisplay lat={location_lat} lon={location_long} />
                            </div>
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {remarks ? remarks : "---"}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            <div>
                              <select
                                onChange={(e) => handleChangeStatus(e, id, idx)}
                                value={approval_status}
                                className="input text-xs py-1"
                              >
                                {punchApproveTypes.map((item, optIdx) => {
                                  return (
                                    <option key={optIdx} value={item.value}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </RoundedContainer>
            <RoundedContainer className="mx-4 mt-4">
              <Pagination
                currentPage={+paramsObject.page_number}
                lengthofItems={list?.data?.total_count}
                limit={+paramsObject.limit}
                onPageChange={handlePageClick}
              />
            </RoundedContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default SinglePersonWebcheckin;
